export const OverwriteScope = {
    Campaign: "CAMPAIGN",
    Template: "MASTER_TEMPLATE",
    EditableGroup: "EDITABLE_GROUP",
    EditableGroupTemplate: "EDITABLE_GROUP_AND_MASTER_TEMPLATE",
} as const;
